module.exports = "/wwwroot/img/TAB.png?ver=76556428";